const External = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 5h5.586l-8.293 8.293 1.414 1.414L19 6.414V12h2V3h-9v2zM4 6H3v15h15v-6.2h-2V19H5V8h4.2V6H4z" fill="#000" />
    </svg>
)

export default External;